import * as React from 'react';
import { CookiesViewModel } from '../empracoTypes';
import { GeneralCookieSettings, GetCookie, SetCookie } from '../generic/CookieFunctions';
import { FaIcon } from '../generic/Icons';
import { ActionButton } from '../generic/UtilityElements';

interface CookiesProps {
  model: CookiesViewModel;
}

export default function Cookies (props: CookiesProps) {
  const { model } = props;
  const settings = GeneralCookieSettings;
  const hasCookie = GetCookie(settings.name);
  const [hidden, hideWindow] = React.useState<boolean>(hasCookie);

  const handleClick = () => {
    SetCookie(settings.name, settings.value, settings.liteTime);
    hideWindow(true);
  };

  if (hidden) {
    return null;
  }

  return(
    <div className='empori-cookies'>
      <div className='empori-cookies-content'>
        <h2>{model.headerText} <FaIcon clsName='fa-regular fa-cookie' /></h2>
        <div dangerouslySetInnerHTML={{__html: model.text}}></div>
        <div className='empori-buttons-container'>
          <ActionButton
            label={model.acceptButtonText}
            action={handleClick}/>
          <ActionButton
            label={model.readMoreButtonText}
            inverted
            action={() => window.location.href = model.readMoreButtonLink}/>
        </div>
      </div>
    </div>
  );
}